import { getKycUrl } from '../service.parameters';
import kycInstance from '../kycServices.parameters';

/* istanbul ignore next */
export const getClientKyc = async () => {
  try {
    const url = await getKycUrl();
    const res = await kycInstance.get(`${url}/kyc`);
    return res.data.update_kyc;
  } catch (error) {
    return false;
  }
};
